import produce from "immer";
import forEach from "lodash/forEach";
import { DeliveryMethodName } from "@Types/addresses";
import { CartState } from "../";

export interface SetShippingOptionMethodAction {
  method: DeliveryMethodName;
  type: "setShippingOptionMethod";
}

export const setShippingOptionMethod = (
  state: CartState,
  action: SetShippingOptionMethodAction
): CartState => {
  return produce(state, (draftState) => {
    if (draftState.cart.shippingOptions[action.method]) {
      draftState.cart.shippingOptions = forEach(draftState.cart.shippingOptions, (option, key) => {
        if (!option) {
          return option;
        }
        if (key === action.method) {
          option.normal.selected = true;
        } else {
          option.normal.selected = false;
        }
        option.express.selected = false;
        return option;
      });
    }
  });
};
